module.exports = __webpack_public_path__ + "static/media/10_of_hearts.5a92a851.png";